/* eslint-disable */
import { StyleSheet } from 'react-native'
import {Fonts} from '../../Themes/'
export default StyleSheet.create({
  container: {
    flex: 1
  },
  text: {
    color: Fonts.style.color.baseColor,
    fontFamily: Fonts.style.font.light
  }

})
